import request from '@/utils/request'


export function GetAllOrderPeople(branchId) {
    return request({
        url: '/OrderPerson/GetAllOrderPeople',
        method: 'post',
        data: {
            BranchId: branchId
        }

    })
}

export function SavePerson(id, branchId, fardId, mablaqBedehkariMojaz , priceType, isActive,description ) {
    return request({
        url: '/OrderPerson/Save',
        method: 'post',
        data: {
            Id: id,
            BranchId: parseInt(branchId),
            FardId: fardId,
            MablaqBedehkariMojaz : mablaqBedehkariMojaz,
            IsActive: isActive,
            Kprice : priceType,
            Description: description
        }

    })
}

export function DeletePerson(id) {
    return request({
        url: '/OrderPerson/Delete',
        method: 'post',
        data: {
            Id: id,
           
        }

    })
}